import { render, staticRenderFns } from "./LiabilityDisclaimer.vue?vue&type=template&id=10bda8de&"
import script from "./LiabilityDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./LiabilityDisclaimer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports